import type ViewType from '../store/schema/ViewType';
import isMessageOrganizationMatrixSupported from './isMessageOrganizationMatrixSupported';

/**
 * Checks whether the reading pane view type is supported given the message list expansion type, returns it it if it is supported
 * Otherwise, returns the next best supported reading pane view type
 * @param messageListExpansionType
 * @param readingPaneViewType
 * @returns the appropriate reading pane view type
 */
export default function getAppropriateReadingPaneViewType(
    messageListExpansionType: ViewType,
    readingPaneViewType: ViewType
): ViewType {
    if (isMessageOrganizationMatrixSupported(messageListExpansionType, readingPaneViewType)) {
        return readingPaneViewType;
    } else if (messageListExpansionType === 1) {
        // Because we don't support branch in RP yet, default to item
        return 2;
    } else {
        return messageListExpansionType;
    }
}
